var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner1.jpg"
    }
  }), _vm._v(" "), _c('myTab', {
    attrs: {
      "tab-list": _vm.tabList,
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle,
      "custom-event": "",
      "smallSize": ""
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), (_vm.activeIndex == 0) ? [_c('b-container', [_c('div', {
    staticClass: "text-left bold mt-40  fs-24"
  }, [_vm._v("媒体事务请联系：")]), _vm._v(" "), _c('div', {
    staticClass: "text-left bold mb-20 fs-24"
  }, [_vm._v("For media, please contact:")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "item block-mb"
  }, [_c('div', {
    staticClass: "item-title fs-24 pl-20 mb-20 "
  }, [_vm._v("\n              广州展联展览服务有限公司\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("联系人/name：陈斌 唐俊")]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n              电 话/phone："), _c('a', {
    attrs: {
      "href": "tel:020-89268976"
    }
  }, [_vm._v("020-89268976")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:89268968"
    }
  }, [_vm._v("89268968")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_c('a', {
    attrs: {
      "href": "mailto:chenb@autoguangzhou.com.cn"
    }
  }, [_vm._v("E-mail：chenb@autoguangzhou.com.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n                            "), _c('a', {
    attrs: {
      "href": "mailto:tangj@autoguangzhou.com.cn"
    }
  }, [_vm._v("tangj@autoguangzhou.com.cn")])])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "item block-mb"
  }, [_c('div', {
    staticClass: "item-title fs-24 pl-20 mb-20"
  }, [_vm._v("\n              中国国际贸易促进委员会汽车行业分会\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("联系人/name：何莹蕊")]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n              电 话/phone："), _c('a', {
    attrs: {
      "href": "tel:010-68594184"
    }
  }, [_vm._v("010-68594184")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_c('a', {
    attrs: {
      "href": "mailto:heyingrui@auto-ccpit.org"
    }
  }, [_vm._v("E-mail：heyingrui@auto-ccpit.org")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n              请点击下载\n              "), _vm._v("\n              媒体合作申请表，填写表格后发送至上述联系人邮箱\n            ")])])])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? [_c('h2', [_vm._v("暂未开通")])] : _vm._e(), _vm._v(" "), _c('page-footer')], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f19dfb72","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaCenter/index.vue
// module id = null
// module chunks = 